export default "__VITE_ASSET__3f62c599__"